import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

// Süper Yönetici: bekleyen hesap silme talepleri. Onay → kullanıcı pasif + kişisel alanlar anonim; iş kayıtları korunur.
export default function DeletionRequests() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/account/deletion-requests").then(({ data }) => setItems(data.items)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  const act = async (r, kind) => {
    if (kind === "approve" && !window.confirm(`${r.user_name} (${r.email}) hesabı kapatılsın ve kişisel alanları anonimleştirilsin mi? İş kayıtları korunur.`)) return;
    try { await api.post(`/account/deletion-requests/${r.id}/${kind}`, { reason: "" }); toast.success(kind === "approve" ? "Hesap kapatıldı ve anonimleştirildi" : "Talep reddedildi"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (!items.length) return null;
  return (
    <div className="mb-3 rounded border border-rose-200 bg-rose-50 p-3" data-testid="deletion-requests-panel">
      <div className="text-sm font-semibold text-rose-800 mb-2">Bekleyen hesap silme talepleri ({items.length})</div>
      <p className="text-[12px] text-rose-700 mb-2">Onay: kullanıcı pasife alınır, oturumları kapanır; ad/e-posta/telefon anonimleşir. Sipariş, cari ve finans kayıtları yasal saklama gereği korunur.</p>
      {items.map((r) => (
        <div key={r.id} className="flex items-center gap-3 text-[13px] py-1 border-t border-rose-100" data-testid={`deletion-request-${r.id}`}>
          <span className="font-medium">{r.user_name}</span><span className="text-slate-600">{r.email} · {r.role}</span>
          <span className="text-slate-500 truncate flex-1">{r.reason || "—"}</span>
          <Button size="sm" variant="outline" className="h-7" onClick={() => act(r, "reject")} data-testid={`deletion-reject-${r.id}`}>Reddet</Button>
          <Button size="sm" className="h-7 bg-rose-600 hover:bg-rose-700" onClick={() => act(r, "approve")} data-testid={`deletion-approve-${r.id}`}>Onayla</Button>
        </div>
      ))}
    </div>
  );
}
